import {
  Box,
  Chip,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useMemo, useEffect } from "react";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import { FilterMatchMode } from "primereact/api";
import { getFamilyAssetColumns } from "../../const/AssertData";
import { assetFamilyMaster } from "../../types/assetTypes";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import {
  getAssetFamilyById,
  getClassCodeMasterDataList,
  getCodeTypeMasterDataList,
  getEquipmentMasterDataList,
  getFamilyAssetMasterDataList,
  getToolsMasterDataList,
  saveAssetFamily,
} from "../../api/Services/masterServie";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import AddIcon from "@mui/icons-material/Add";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { PAGESTART, PAGESEND } from "../../api/endpoint";
import { RootState } from "../../store/Reduxstore";

interface FamilyAssetProps {
  setPathname: (path: string) => void;
}

const FamilyAsset: React.FC = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<assetFamilyMaster[]>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [familyData, setFamilyData] = useState<assetFamilyMaster>({
    familyAssetId: 0,
    familyName: "",
    familyCode: "",
    optional1Number: null,
    optional2Number: null,
    optional3Number: null,
    optional4Number: null,
    optional5String: null,
    optional6String: null,
    optional7String: null,
    optional8String: null,
    selectedClassCodes: [] as string[],

    classCodeIds: []

  });


  // Memoized column definition
  const columns = useMemo(() => getFamilyAssetColumns(), []);

  if (columns.filter((val) => val.field === "action").length === 0) {
    columns.push({
      field: "action",
      header: "Action",
      sortable: false,
      filter: false,
      filterField: "action",
      filterPlaceholder: "Search",
      style: { minWidth: "12rem" },
      body: (rowData: any) => (
        <ReusablePrimeButton
          icon="pi pi-pencil"
          className="p-button-rounded p-button-outlined"
          onClick={() => handleEditFamilyAsset(rowData.familyAssetId)}
        />
      ),
    });
  }

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );

  //  useEffect(() => {
  //           const fetchCountry = async () => {
  //             try {
  //               const response = await getCodeTypeMasterDataList(PAGESTART, PAGESEND, {});
  //               console.log("R:", response);
  //               if (response.status.code === 200) {
  //                 setCodeType(response.data.map(typeCodeIds => ({
  //                   id: typeCodeIds.typeCodeId,
  //                   name: typeCodeIds.typeCode,
  //                 })));

  //               } else {
  //                 setCodeType([]);
  //                 CustomMessage(response.status.message, "error", enqueueSnackbar);
  //               }
  //             } catch (error: any) {
  //               CustomMessage(error.message, "error", enqueueSnackbar);
  //             }
  //           };

  //           fetchCountry();
  //         }, []);
  const handleEditFamilyAsset = async (familyAssetId: number) => {
    dispatch(setLoading(true));
    try {
      const response = await getAssetFamilyById(familyAssetId);
      let { data, status } = response;

      console.log("Fetched family asset data:", data);  // <-- log fetched data

      if (status.code === 200 && data) {
        // Map classCodeIds to actual class codes for UI display
        const selectedCodes = (data.classCodeIds || [])
          .map((id: number) => {
            const match = classCodes.find((code) => code.value === id);
            return match ? match.classCode : null;
          })
          .filter((code): code is string => Boolean(code));

        console.log("Computed selectedClassCodes:", selectedCodes); // <-- log computed UI-only field

        // Set the state including UI-only selectedClassCodes
        setFamilyData({
          ...data,
          selectedClassCodes: selectedCodes, // only for UI, NOT in DB
        });

        setOpenDialog(true);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const onFetchData = async (page: number, rows: number, filter?: Record<string, any>) => {
    dispatch(setLoading(true));
    try {
      const { data, status, pagination } = await getFamilyAssetMasterDataList(page, rows, filter ?? filterData);
      if (status.code === 200 && data?.length > 0) {
        setData(data);
        setPagination({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setData([]);
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const [classCodes, setClassCodes] = useState<
    {
      value: number;         // classCodeId
      label: string;         // classCodeDes
      classCode: string;     // actual classCode
    }[]
  >([]);


  useEffect(() => {
    if (classCodes.length === 0) getclassCodesList(1, PAGESEND);
  }, [classCodes]);


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setFamilyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setOpenDialog(false);
    setFamilyData({
      familyAssetId: 0,
      familyName: "",
      familyCode: "",
      optional1Number: null,
      optional2Number: null,
      optional3Number: null,
      optional4Number: null,
      optional5String: null,
      optional6String: null,
      optional7String: null,
      optional8String: null,
      selectedClassCodes: [] as string[],

      classCodeIds: []

    });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event?.preventDefault();
    const updatedFamily: assetFamilyMaster = {
      ...familyData,
      familyAssetId: familyData.familyAssetId || 0,
      familyName: familyData.familyName || "",
      familyCode: familyData.familyCode || "",
      optional1Number: familyData.optional1Number || null,
      optional2Number: familyData.optional2Number || null,
      optional3Number: familyData.optional3Number || null,
      optional4Number: familyData.optional4Number || null,
      optional5String: familyData.optional5String || null,
      optional6String: familyData.optional6String || null,
      optional7String: familyData.optional7String || null,
      optional8String: familyData.optional8String || null,
      classCodeIds: familyData.classCodeIds || []
    };

    if ((updatedFamily as any).selectedClassCodes) {
      delete (updatedFamily as any).selectedClassCodes;
    }
    if (updatedFamily.familyName === "") {
      CustomMessage("Add the name", "error", enqueueSnackbar);
      return;
    }

    // Convert empty string values to null
    Object.keys(updatedFamily).forEach((key) => {
      if (updatedFamily[key as keyof typeof updatedFamily] === "") {
        (updatedFamily as any)[key] = null;
      }
    });

    dispatch(setLoading(true));
    try {
      const response = await saveAssetFamily(updatedFamily);
      let { status } = response;
      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message, "success", enqueueSnackbar);
        handleClear();
        //onFetchData(pagination.page, pagination.rows);
        onFetchData(PAGESTART, PAGESEND, filterData);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const getclassCodesList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getClassCodeMasterDataList(page, rows, {
        classCodeId: { value: "", matchMode: "startsWith" },
      });

      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.classCodeId,             // value = classCodeId
          label: val.classCodeDes ?? "",      // label = classCodeDes (for dropdown)
          classCode: val.classCode ?? "",     // store classCode separately
        }));
        console.log("formatted class codes before setting state:", updatedData);
        setClassCodes(updatedData);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleClassCodeChange = (e: MultiSelectChangeEvent) => {
    const selectedIds = e.value as number[];

    // Filter classCodes to get the selected ones by id
    const selectedCodes = classCodes
      .filter((code) => selectedIds.includes(code.value))  // value is classCodeId
      .map((code) => code.classCode);  // classCode is the actual class code string

    setFamilyData((prev) => ({
      ...prev,
      classCodeIds: selectedIds,
      selectedClassCodes: selectedCodes,
    }));
  };

  useEffect(() => {
    if (familyData.classCodeIds?.length && classCodes.length) {
      const selectedCodes = classCodes
        .filter((code) => familyData.classCodeIds.includes(code.value))
        .map((code) => code.classCode);  // or whatever the property is that holds the code string

      setFamilyData((prev) => ({
        ...prev,
        selectedClassCodes: selectedCodes,
      }));
    }
  }, [familyData.classCodeIds, classCodes]);
  const controlHeight = 100; // adjust as needed
  const userDetails = useSelector((state: RootState) => state.auth)




  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {userDetails.role.some(
          r => r.roleName === "Admin" || r.roleName === "Assets List Write"
        ) && (
            <Chip
              className="btn-black-outlined mb-3"
              label="New"
              color="warning"
              onClick={() => setOpenDialog(true)}
              icon={<AddIcon />}
              variant="outlined"
            />
          )}
      </div>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          borderRadius: 3,
          boxShadow: 3,
          padding: 2,
        }}
      >
        <ReusableDataTable
          data={data}
          columns={columns}
          onFetchData={onFetchData}
          emptyMessage="No data found."
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          selectionMode="multiple"
          rowsPerPageOptions={[5, 10, 25, 50]}
          //filters={filters}
          pagination={pagination}
          setPagination={setPagination}
          filters={filterData}
          setFilters={setFilterData}
          onRowDoubleClick={(rowData) => {
            console.log('Double-click row:', rowData);
            handleEditFamilyAsset(rowData.familyAssetId);
          }}
        />
      </Box>
      <ReusablePrimeReactDialog
        header="Add Family Asset"
        visible={openDialog}
        onHide={handleClear}
        style={{ zIndex: 2100 }} // Add this
      >
        <form>


          <div className="mb-3">
            <h6>Asset Family</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.familyName}
              name="familyName"
              onChange={handleChange}
              sx={{ mt: 0 }}
              required
            />
          </div>
          <div className="mb-3">
            <h6>Family Code</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.familyCode}
              name="familyCode"
              onChange={handleChange}
              sx={{ mt: 0 }}
              required
            />
            <Box sx={{ mt: 2, mb: 1, fontWeight: "bold", position: "relative" }}>
              <Typography variant="body1">Select Class Code</Typography>


              <MultiSelect
                value={familyData.classCodeIds}
                options={classCodes}
                optionLabel="label"
                optionValue="value"
                placeholder="Select Class Code"
                style={{ width: "100%", marginTop: 4 }}
                appendTo="self"
                filter
                onChange={handleClassCodeChange}

              />
            </Box>
          </div>


          <div className="mb-3">
            <h6>Class Codes</h6>
            <TextField

              fullWidth
              variant="outlined"
              value={(familyData.selectedClassCodes ?? []).join(", ")
              }  // join array to string
              InputProps={{
                readOnly: true,
              }}
              sx={{ mt: 2 }}
            />

          </div>


          <div className="mb-3">
            <h6>optional-1_Number</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional1Number}
              name="optional1Number"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          <div className="mb-3">
            <h6>optional-2_Number</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional2Number}
              name="optional2Number"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          <div className="mb-3">
            <h6>optional-3_Number</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional3Number}
              name="optional3Number"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          <div className="mb-3">
            <h6>optional-4_Number</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional4Number}
              name="optional4Number"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          <div className="mb-3">
            <h6>optional-5_String</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional5String}
              name="optional5String"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          <div className="mb-3">
            <h6>optional-6_String</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional6String}
              name="optional6String"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          <div className="mb-3">
            <h6>optional-7_String</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional7String}
              name="optional7String"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          <div className="mb-3">
            <h6>optional-8_String</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={familyData.optional8String}
              name="optional8String"
              onChange={handleChange}
              sx={{ mt: 0 }}
            />
          </div>
          {/* <Typography variant="body1" sx={{ mt: 2, mb: 0, fontWeight: "bold" }}>
            Select Type Code
          </Typography>
          <MultiSelect
            value={familyData.typeCodeIds}
            options={codeType}
            optionLabel="name"
            optionValue="id"
            placeholder="Select Type Code"
            style={{ width: "100%" }}
            appendTo="body"
            onChange={(e: MultiSelectChangeEvent) =>
              setFamilyData((prev) => ({
                ...prev,
                typeCodeIds: e.value as number[],
              }))
            }
          /> */}



          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: "30px"
          }}>
            <ReusablePrimeButton
              onClick={handleClear}
              severity="contrast"
              title="Cancel"

            >
              Cancel
            </ReusablePrimeButton>
            <ReusablePrimeButton className="ms-1" severity="info" onClick={handleSubmit} allowedRoles={["Admin", "Assets List Write"]}>
              Submit
            </ReusablePrimeButton>
          </div>
        </form>
      </ReusablePrimeReactDialog>
    </>
  );
};

export default FamilyAsset;
